import { render, staticRenderFns } from "./Cancelamento.vue?vue&type=template&id=32c75108&scoped=true"
import script from "./Cancelamento.vue?vue&type=script&lang=js"
export * from "./Cancelamento.vue?vue&type=script&lang=js"
import style0 from "./Cancelamento.vue?vue&type=style&index=0&id=32c75108&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c75108",
  null
  
)

export default component.exports